
import { Component, Vue } from "vue-property-decorator";

@Component({ name: 'open-tongue-components-collectStep3',
    components: {
    }
})
export default class OpenTongueCollectStep3 extends Vue {

    viewReport() {
        this.$emit("viewReport");
    }

    tryAgain(){
        this.$emit("tryAgain");
    }
}
